<template>
    <div class="app">
        <div class="app-body">
            <main class="main">
                <div class="container-fluid">
                    <router-view></router-view>
                </div>
            </main>
        </div>
    </div>
</template>

<script>
import nav from '@/_nav'
import {
    Header as AppHeader,
    SidebarToggler,
    Sidebar as AppSidebar,
    SidebarFooter,
    SidebarForm,
    SidebarHeader,
    SidebarMinimizer,
    SidebarNav,
    Aside as AppAside,
    AsideToggler,
    Footer as TheFooter,
    Breadcrumb,
} from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdown from './DefaultHeaderDropdown'

export default {
    components: {
        AsideToggler,
        AppHeader,
        AppSidebar,
        AppAside,
        TheFooter,
        Breadcrumb,
        DefaultAside,
        DefaultHeaderDropdown,
        SidebarForm,
        SidebarFooter,
        SidebarToggler,
        SidebarHeader,
        SidebarNav,
        SidebarMinimizer,
    },
    data() {
        return {
            navItems: nav.items,
        }
    },
    computed: {
        name() {
            return this.$route.name
        },
        list() {
            return this.$route.matched.filter(route => route.name || route.meta.label)
        },
    },
}
</script>

<style lang="scss" scoped>
@media (min-width: 992px) {
    html:not([dir='rtl']) .sidebar-lg-show.sidebar-fixed .main,
    html:not([dir='rtl']) .sidebar-lg-show.sidebar-fixed .app-footer,
    html:not([dir='rtl']) .sidebar-show.sidebar-fixed .main,
    html:not([dir='rtl']) .sidebar-show.sidebar-fixed .app-footer {
        margin-left: 0;
    }
}
</style>
